import type { ErrorInfo } from 'react'

import image from '../assets/parachute-tractor.svg'
import { PanoramaButton } from './Button'
import { ImageWithMessage } from './ImageWithMessage'

type FallbackComponentProps = {
  error: Error
  errorInfo?: ErrorInfo
  signOut?: () => void
}
/**
 *
 * Full page implementation of the Fallback-type component that displays an error message with the parachuting tractor image.
 * Frequently used in conjunction (passed through as a prop) with `ErrorBoundary`
 *
 * @group UI Components
 * @apiParam {errorProps}
 */
export const AppCrashFallback = (errorProps: FallbackComponentProps) => {
  return (
    <div className="relative h-screen w-screen">
      <ImageWithMessage
        heading="Uh Oh..."
        message="The app has crashed. Please refresh and try again."
        imageSrc={image}
        {...errorProps}
      />
      {errorProps.signOut && (
        <PanoramaButton onClick={errorProps.signOut} className="absolute right-8 top-8 p-4">
          Sign out
        </PanoramaButton>
      )}
    </div>
  )
}
